import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.index-of";
import _pick from "lodash/pick";
import _find from "lodash/find";
import _merge from "lodash/merge";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultStep = {
  id: '',
  title: '',
  component: null,
  isComplete: function isComplete() {
    return true;
  },
  additionalProps: {},
  webConfig: {
    countStep: true,
    hideHeader: false
  }
}; // gets web specific config and meta

var getWebConfig = function getWebConfig(steps, currentStep) {
  var stepIndex = steps.indexOf(currentStep); // only count steps that are supposed to count towards the total

  var displayTotalSteps = steps.filter(function (step) {
    return step.webConfig.countStep;
  }).length; // calulcate the current step leaving out non counted steps

  var displayStepIndex = steps.reduce(function (prev, step, i) {
    if (i > stepIndex) return prev;
    return step.webConfig.countStep ? prev + 1 : prev;
  }, 0);
  return _objectSpread(_objectSpread({}, currentStep.webConfig), {}, {
    displayTotalSteps: displayTotalSteps,
    displayStepIndex: displayStepIndex
  });
};

export default (function (flow, state, flowState) {
  // merge all steps with the default step options
  var steps = flow.steps.map(function (step) {
    var mergeStep = typeof step === 'function' ? step(state, flowState) : step;
    return _merge({}, defaultStep, mergeStep);
  }); // find the first step that's not complete

  var currentStep = _find(steps, function (step) {
    return !step.isComplete(state, flowState);
  }); // return false if all steps are complete


  if (!currentStep) return false;
  return _objectSpread(_objectSpread({
    // the index of the step of the step in the steps array
    stepIndex: steps.indexOf(currentStep)
  }, _pick(currentStep, ['id', 'component', 'title', 'route', 'additionalProps', 'unComplete'])), {}, {
    webConfig: getWebConfig(steps, currentStep)
  });
});